import FlagsIpcRouter, { type FlagsIpcRouterType } from '@shared/ipc/routers/FlagsIpc.router'

class FlagsIpcRenderer extends FlagsIpcRouter implements FlagsIpcRouterType {
  async refresh() {
    return this.exec('refresh')
  }
}

export default new FlagsIpcRenderer()
